import Modal from "../modal/Modal";
import {Form, Formik} from "formik";
import React, {useEffect, useState} from "react";
import RouteAutoComplete, {RouteAutoCompleteChangeEvent} from "../routes/RouteAutocomplete";
import {DropDownOption} from "../dropdown/types";
import Alert from "../alerts/Alert";
import {ReaderPromo} from "./types";

interface AddRouteCloseProps {
    closeAction: CallableFunction
    readerPromo: ReaderPromo
    setReaderPromo: CallableFunction
}

export const AddRouteModal = (props: AddRouteCloseProps) => {
    const [route, setRoute] = useState<DropDownOption>()
    const [errorMessage, setErrorMessage] = useState('')

    useEffect(() => {
        setTimeout(() => {
            setErrorMessage('')
        }, 5000)
    }, [errorMessage])

    const handleAddRoute = () => {
        let newReaderPromo = {...props.readerPromo}
        if (route && props.readerPromo) {
            const readerPromoRouteIds = props.readerPromo.routes.map(route => {
                return route.routeId
            });
            if (readerPromoRouteIds.includes(route.id)) {
                setErrorMessage('Reader Promo Already on Route')
                return;
            }
            newReaderPromo.routes = [...newReaderPromo.routes, {routeId: route.id, routeName: route.value}]
        }
        props.setReaderPromo(newReaderPromo)
        props.closeAction();
    }

    const errorMessageHTML = errorMessage ? <Alert message={errorMessage} type="error"/> : null

    return (
        <Modal title={"Add Reader Promo Route"} closeAction={props.closeAction}>
            <Formik initialValues={{route: undefined}}
                    onSubmit={() => {
                        handleAddRoute()
                    }}
            >
                {() => {
                    const handleRouteChanged = (event: RouteAutoCompleteChangeEvent) => {
                        if (event.route) {
                            setRoute(event.route)
                        } else {
                            setRoute(undefined);
                        }
                    }

                    return (
                        <Form >
                            <div className={"h-48"}>
                                <label htmlFor="contactUserId" className="form-label">Route:</label>
                                <RouteAutoComplete value={route ? route.value : ''} onChange={handleRouteChanged} />
                            </div>
                            {errorMessageHTML}
                            <div className="flex">
                                <button className="ml-auto bg-yellow-300 button" disabled={!route}>Add Route</button>
                                <button className="ml-4 bg-gray-300 button" onClick={() => props.closeAction()} type="button"> Cancel </button>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </Modal>
    )
}